
<template>
  <div class="plasticMachinery" v-loading="loading">
    <div class="title">产品信息（塑料机械）</div>
    <el-divider></el-divider>

    <!-- 基本信息 -->
    <div class="companyInformation">
      <div class="content">
        <!-- 左侧表单 -->
        <div class="left">
          <div class="info">
            <!-- <el-form ref="form" :model="form" label-width="80px"> -->
            <el-form label-width="80px" :disabled="disabled">
              <el-form-item label="品名" >
                <el-select
                :disabled="true"
                  v-model="brand"
                  placeholder="请选择品名"
                  ref="brandScroll"
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="产品信息标题">
                <el-input
                  placeholder="请正确输入产品信息标题"
                  v-model="productTitle"
                  maxlength="25"
                ></el-input>
              </el-form-item>

              <el-form-item label="单价">
                <el-input
                  placeholder="请输入真实价格"
                  v-model="price"
                ></el-input>
                <span class="word">元/台</span>
              </el-form-item>
              <el-form-item label="数量">
                <el-input placeholder="请输入数量" v-model="number"></el-input>
                <span class="word">台</span>
              </el-form-item>

              <div class="companytype">
                <div class="leftText">交货方式</div>
                <div
                  class="selectItem"
                  v-for="(item, index) in wayList"
                  :key="index"
                  @click="selectWay(index)"
                >
                  <img
                    src="../../assets/bussiness/btn_dl_sel@2x.png"
                    class="checkImage"
                    alt=""
                    v-if="wayIndex == index"
                  />
                  <div class="checkbox" v-else></div>
                  {{ item.name }}
                </div>
              </div>

              <el-form-item label="交货日期" v-if="type == '预定'">
                <el-date-picker
                  v-model="date"
                  type="date"
                  placeholder="请选择交货日期"
                  @change="changeDate"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="交货地">
                <el-cascader
                  placeholder="请选择交货地"
                  :options="addressList"
                  :props="{ expandTrigger: 'hover', value: 'label' }"
                  @change="handleChange"
                  v-model="handleAddress"
                ></el-cascader>
              </el-form-item>

              <el-form-item label="品牌">
                <el-input placeholder="请输入品牌" v-model="kind"></el-input>
              </el-form-item>

              <el-form-item label="生产商">
                <el-input
                  placeholder="请输入生产商"
                  v-model="producer"
                ></el-input>
              </el-form-item>

              <el-form-item label="型号">
                <el-input
                  placeholder="请输入产品型号"
                  v-model="typeNumber"
                ></el-input>
              </el-form-item>

              <el-form-item label="包装规格">
                <el-input
                  placeholder="请输入包装规格"
                  v-model="size"
                ></el-input>
              </el-form-item>

              <el-form-item label="电机功率">
                <el-input placeholder="请输入功率" v-model="power"></el-input>
              </el-form-item>

              <el-form-item label="机械成分">
                <el-select v-model="ingredient" placeholder="请正确选择">
                  <el-option
                    v-for="item in ingredientOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 右侧上传处 -->
        <div class="right">
          <div class="store">
            <div class="leftText">图片</div>
            <div class="uploadPlace">
              <el-upload
                :disabled="disabled"
                :class="{ hide: fifthImage }"
                :action="imgUpload"
                accept="image/*"
                list-type="picture-card"
                :limit="5"
                :on-success="successChange"
                :on-remove="hideLogo"
                :file-list="pictureList"
              >
                <div class="uplogo">
                  <img
                    src="../../assets/bussiness/icon_rzgys_sc@2x.png"
                    alt=""
                    class="image"
                  />
                  <span class="text">请上传</span>
                </div>
              </el-upload>
              <span>（最多上传5张）</span>
            </div>
          </div>

          <div class="video">
            <div class="leftText">视频</div>
            <div class="uploadPlace">
              <el-upload
                :disabled="disabled"
                accept="video/*"
                ref="videoUpload"
                :action="imgUpload"
                list-type="picture-card"
                :multiple="false"
                :show-file-list="false"
                :on-progress="progressProduct"
                :on-success="productSuccess"
                :on-remove="hideproduct"
              >
                <div
                  class="uplogo"
                  v-if="videoUrl == ''"
                  :class="{ hide: videoUrl }"
                >
                  <img
                    src="../../assets/bussiness/icon_rzgys_sc@2x.png"
                    alt=""
                    class="image"
                  />
                  <span class="text">请上传</span>
                </div>
                <img
                  class="closeIcon"
                  src="../../assets/bussiness/gb@3x.png"
                  v-if="videoUrl"
                  alt=""
                  @click.stop="changeVideoUrl"
                />
                <video class="videoBox" :src="videoUrl | urlLoad" v-if="videoUrl"></video>
              </el-upload>
              <span>（只可上传一个，限30S以内）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="20%"
      class="show-Totast-forever-flex-name"
      >
      <span>您的体验发布次数已用完,需开通优塑会员!</span>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tzhy()">开通优塑会员</el-button>
      </span>
    </el-dialog>
    <!-- 按钮 -->
    <div v-if="disabled == false">
      <button class="cancelButton button" @click="cancel">取消</button>
      <button class="cancelButton button" @click="submit(0)">保存草稿</button>
      <button class="submitButton button" @click="submit(1)">提交上线</button>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import regionJson from "@/json/region";
import bus from "../../utils/bus.js";
import { urlLoad } from '/src/filters/index.js'

export default {
  name: "plasticMachinery",
  props: {
    data1: Object,
    data: Object,
    disabled: Boolean,
  },
  data() {
    return {
      dialogVisible:false,
      loading: false,
      sljxOptions: [
        { name: "造粒机" },
        { name: "注塑机" },
        { name: "吹膜机" },
        { name: "吹瓶机" },
        { name: "破碎机" },
        { name: "分选机" },
        { name: "清洗机" },
        { name: "搅拌机" },
        { name: "打包机" },
        { name: "冷水机" },
        { name: "挤出机" },

        { name: "干燥机" },
        { name: "机械手" },
        { name: "中空成型机" },
        { name: "发泡机" },
        { name: "吸塑机" },
        { name: "切粒机" },
        { name: "分离机" },
        { name: "机械配件" },
        { name: "其他机械" },
      ],
      productTitle: "",
      price: "",
      number: "",
      addressList: [],
      kind: "",
      producer: "",
      typeNumber: "",
      size: "25KG",
      power: "",
      type: "",
      ingredient: "",
      ingredientOptions: [
        { value: "全新机" },
        { value: "九成新" },
        { value: "八成新" },
        { value: "七成新" },
        { value: "六成新" },
        { value: "五成新" },
        { value: "四成新" },
        { value: "三成新" },
        { value: "二成新" },
        { value: "一成新" },
      ],
      brand: "",
      brandOptions: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      productId: 0,
      date: "",
      // brandId: "",
      handleAddress: [],
      pictureList: [],
      wayList: [{ name: "现货" }, { name: "预定" }],
      wayIndex: -1,
      userInfo: {},
      draftId: "",
      // 图片
      imgUpload: "https://www.yousubao-01.com/util/file/upload",
      imageList: "",
      imageUrl: "",
      fifthImage: false,
      videoUrl: "",
    };
  },
  watch: {
    data(newData) {
      if (newData) {
        this.changeID();
      }
    },
  },
  created() {
    this.addressList = regionJson;
    this.changeID();
    this.brandOptions = this.sljxOptions;
  },

  mounted() {
    // console.log(this.$refs.brandScroll);
    // this.$refs.brandScroll.$refs.scrollbar.$refs.wrap.addEventListener(
    //   "scroll",
    //   this.brandScolling
    // );
    bus.$on("updateDefaultProvince", (val) => {
      this.handleAddress = val;
    });
    bus.$on("updateDefaultCity", (val) => {
      this.handleAddress = val;
    });
    let info = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userInfo = info;
  },

  methods: {
    // 已上线/下线列表不同商品跳转
    changeID() {
      console.log("塑料机械this.data1", this.data1);
      // console.log("已上线塑料机械data", this.data);
      if (this.data1.brandValue) {
        this.loading = false;
        this.brand = this.data1.brandValue;
        // this.brandId = this.data1.brandId;
        this.handleAddress = [
          this.data1.defaultProvince,
          this.data1.defaultCity,
        ];
        this.type = this.wayIndex = 0;
        this.type = this.wayList[this.wayIndex].name;
      } else {
        this.loading = false;
        this.productId = this.data.productId;
        this.draftId = this.data.id;
        this.brand = this.data.productName;
        this.productTitle = this.data.title;
        this.price = this.data.price;
        this.number = this.data.number;
        this.type =
          this.data.deliveryType == 1
            ? (this.wayIndex = 0)
            : (this.wayIndex = 1); //交货方式
        this.date = this.data.deliveryDate;
        this.handleAddress = [
          this.data.deliverySiteProvince,
          this.data.deliverySiteCity,
        ];
        this.kind = this.data.markName;
        this.producer = this.data.manufacturersName;
        this.typeNumber = this.data.productModel;
        this.size = this.data.packaging;
        this.power = this.data.productMotorPower;
        this.ingredient = this.data.productIngredient;
        this.type = this.wayList[this.wayIndex].name;
        this.imageList = this.data.imageUrl;

        // 图片
        this.pictureList = this.data.imageUrl.split(",");
        this.pictureList = this.pictureList.map((item) => {
          return {
            name: item,
            url: urlLoad(item),
          };
        });
        // 视频
        this.videoUrl = this.data.videoUrl;

        // console.log("回显this.handleAddress", this.handleAddress);
        // console.log("回显this.city",this.city);
      }
    },

    // 选择日期
    changeDate() {
      console.log("this.date", this.date);
    },

    // 点击交货方式
    selectWay(index) {
      this.wayIndex = index;
      this.type = this.wayList[this.wayIndex].name;
      console.log("this.type", this.type);
    },

    // 选择交货地
    handleChange(label) {
      this.province = label[0];
      this.city = label[1];
      this.data1.defaultProvince = label[0];
      this.data1.defaultCity = label[1];
      this.data.deliverySiteProvince = label[0];
      this.data.deliverySiteCity = label[1];
    },

    // 图片上传
    successChange(response, file, fileList) {
      var storeList = [];

      // 判断图片长度
      fileList.forEach((item) => {
        var image = "";
        if (item.response) {
          image = item.response.result;
        } else {
          image = item.url;
        }
        storeList.push(image);
      });
      this.imageList = storeList.toString();

      if (fileList.length == 5) {
        this.fifthImage = true;
      }
    },
    hideLogo() {
      setTimeout(() => {
        this.fifthImage = false;
      }, 1000);
    },

    // 产品视频上传
    productSuccess(response, file) {
      this.loading = false;
      this.videoUrl = response.result;
      utils.findvideocover(file.url, file);
    },
    progressProduct() {
      this.loading = true;
    },
    hideproduct() {
      setTimeout(() => {
        this.videoUrl = "";
      }, 900);
    },
    changeVideoUrl() {
      this.videoUrl = "";
    },

    // status 0保存 1提交
    async submit(status) {
      console.log("this.type", this.type);
      console.log("this.date", this.date);
      if (
        // status为1判断是否填写完整
        // 1)发布供应页跳转进来提交
        status == 1 &&
        this.data1.brandValue !== undefined &&
        (this.brand == "" ||
          this.productTitle == "" ||
          this.price == "" ||
          this.number == "" ||
          this.type == "" ||
          (this.type == "预定" && this.date == "") ||
          (this.province == "" && this.city == "") ||
          (this.data1.defaultProvince == undefined &&
            this.data1.defaultCity == undefined) 

          // 手机端下面选项可以不填，用户后台同步
          // ||this.kind == "" ||
          // this.producer == "" ||
          // this.typeNumber == "" ||
          // this.size == "" ||
          // this.power == "" ||
          // this.ingredient == ""
          )
      ) {
        this.$message.error("当前信息填写不完整，请检查并填写完整");
      } else if (
        // 2)发布供应页跳转进来提交
        status == 1 &&
        this.data.productName !== undefined &&
        (this.brand == "" ||
          this.productTitle == "" ||
          this.price == "" ||
          this.number == "" ||
          this.type == "" ||
          (this.type == "预定" && this.date == "") ||
          (this.data.deliverySiteProvince == undefined &&
            this.data.deliverySiteCity == undefined)

          // 手机端下面选项可以不填，用户后台同步
          // ||this.kind == "" ||
          // this.producer == "" ||
          // this.typeNumber == "" ||
          // this.size == "" ||
          // this.power == "" ||
          // this.ingredient == ""
          )
      ) {
        this.$message.error("请检查并填写完整信息");
      } else if (status == 1 && this.imageList == "") {
        this.$message.error("请至少上传一张产品图片");
      } else {
        for (let i = 0; i < this.brandOptions.length; i++) {
          if (this.brand == this.brandOptions[i].name) {
            this.productId = this.brandOptions[i].id;
            break;
          }
        }
        let params = {
          type: "MECHANICAL", //塑料机械
          productName: this.brand,
          productId: this.productId,
          title: this.productTitle,
          price: this.price,
          number: this.number,
          deliveryType: this.type == "现货" ? 1 : 0,
          deliverySiteProvince: this.data1.defaultProvince || this.province,
          deliverySiteCity: this.data1.defaultCity || this.city,
          markName: this.kind,
          manufacturersName: this.producer,
          productModel: this.typeNumber,
          packaging: this.size,
          productMotorPower: this.power,
          productIngredient: this.ingredient,
          imageUrl: this.imageList,
          deliveryDate: this.date || "",
          hasPc:true,
        };
        params.status = status;
        if (this.videoUrl) {
          params.videoUrl = "";
          params.videoUrl = this.videoUrl;
        } else {
          params.videoUrl = "";
        }

        if (status == 1) {
          //status 1提交
          // 已上线，下线列表跳转
          if (this.data.id) {
            params.id = this.draftId;
            params.memberId = this.userInfo.id;
            let res = await this.$apiFun.saveDraft(params);
            if (res.code == 200) {
              this.$message.success("已发布成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          } else {
            // 发布供应跳转
            let res = await this.$apiFun.releaseSupply(params);
            if (res.code == 200) {
              this.$message.success("已发布成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          }
        } else if (status == 0) {
          //status 0保存
          // 已上线，下线列表跳转
          if (this.data.id) {
            params.id = this.draftId;
            params.memberId = this.userInfo.id;
            let res = await this.$apiFun.saveDraft(params);
            if (res.code == 200) {
              this.$message.success("已保存成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          } else {
            // 发布供应跳转
            let res = await this.$apiFun.releaseSupply(params);
            if (res.code == 200) {
              this.$message.success("已保存成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          }
        }
      }
    },
    tzhy() {
      this.dialogVisible = false
      this.$router.push("accountEdit");
    },
    // 保存/提交成功后返回上级页面
    successBack() {
      setTimeout(() => {
        this.$emit("backToMain", {
          typeValue: this.data1.typeValue,
          status: this.data.status || "",
        });
      }, 1800);
    },

    cancel() {
      // console.log("this.data1",this.data1);
      // console.log("this.data",this.data);
      this.$emit("backToMain", {
        typeValue: this.data1.typeValue || "",
        status: this.data.status || "",
      });
    },
  },
};
</script>

<style lang="less" scoped>
	.show-Totast-forever-flex-name {
		font-family: PingFang SC;
		font-size: 28px;
		color: #333333;
		justify-content: center;
	}
.plasticMachinery {
  background: #ffffff;
  box-shadow: 0px 3px 20px 0px rgba(230, 230, 230, 0.8);
  border-radius: 10px;
  padding: 0.3rem 0.5rem;
  font-family: Microsoft YaHei;
  height: 100%;
  .title {
    font-size: 0.24rem;
    font-weight: bold;
    color: #333333;
    line-height: 0.3rem;
    margin-bottom: 0.35rem;
    text-align: left;
  }

  // 基本信息
  .companyInformation {
    text-align: left;
    height: auto;

    .content {
      display: flex;
      // 左侧表单
      .left {
        width: 52%;
        // background: yellow;

        .info {
          border-right: 2px solid #efefef;

          // element表单样式
          /deep/ .el-form {
            .companytype {
              font-size: 0.16rem;
              display: flex;
              align-items: center;
              margin-bottom: 25px;
              .leftText {
                width: 110px;
              }
              .selectItem {
                display: flex;
                cursor: pointer;
                margin-left: 0.3rem;
                justify-content: space-between;

                .checkImage {
                  width: 0.22rem;
                  height: 0.22rem;
                }
                .checkbox {
                  width: 0.2rem;
                  height: 0.2rem;
                  border: 1px solid #999999;
                }
              }
              .selectItem:nth-child(2) {
                margin-left: 0;
              }
            }
            .el-input {
              width: 90%;
            }
            .el-textarea {
              width: 90%;
              height: 4.9rem;
            }
            .el-checkbox__inner {
              width: 0.2rem;
              height: 0.2rem;
              border: 1px solid #999999;
              border-radius: 2px;
              &::after {
                height: 0.12rem;
                left: 0.07rem;
              }
            }
            // 点击样式
            .is-checked {
              .el-checkbox__inner {
                background-color: #f42551;
              }
            }

            .el-form-item__label,
            .el-input__inner,
            .el-textarea__inner,
            .el-checkbox__label {
              font-size: 0.16rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .el-input__inner,
            .el-input__count {
              background-color: #f5f5f5;
            }

            .el-textarea__inner {
              height: 100%;
              background-color: #f5f5f5;
            }

            .el-select,
            .el-cascader {
              width: 100%;
            }

            .el-form-item__label {
              width: 110px !important;
              text-align: left;
            }
            .el-form-item__content {
              margin-left: 110px !important;
              .word {
                position: absolute;
                right: 0.5rem;
                font-size: 0.16rem;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }
      }

      // 右侧上传处
      .right {
        width: 47%;
        // background: skyblue;
        margin-left: 3%;

        .store,
        .video {
          display: flex;
          justify-content: space-evenly;
          font-size: 0.16rem;
          font-weight: 400;
          margin-bottom: 0.3rem;
          .leftText {
            width: 35%;
            color: #333333;
          }
          .uploadPlace {
            width: 46.9%;
            color: #999999;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            /deep/ .el-upload--picture-card {
              width: 1rem;
              height: 1rem;
              background: #f5f5f5;
              border-radius: 5px;
              cursor: pointer;
              margin-bottom: 0.1rem;
              border: none;
              position: relative;

              .uplogo {
                height: 100%;
                position: relative;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .image {
                  height: 0.36rem;
                  width: 0.36rem;
                }
                .text {
                  line-height: 0.3rem;
                }
              }
              .closeIcon {
                position: absolute;
                top: -0.1rem;
                right: -0.1rem;
                z-index: 2;
                width: 0.2rem;
              }
              .videoBox {
                width: 1rem;
                height: 1rem;
                object-fit: fill;
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            .hide /deep/.el-upload--picture-card {
              display: none;
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 1rem;
              height: 1rem;
            }
          }
        }

        .store {
          // height: 55%;
          height: auto;
        }

        .video {
          .uploadPlace {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }

  // 按钮
  .button {
    width: 1.9rem;
    height: 0.4rem;
    border-radius: 5px;
    font-size: 0.16rem;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.3rem;
    border: 1px solid;
    margin-top: 0.8rem;
    cursor: pointer;
    margin-left: 0.2rem;
  }
  .cancelButton {
    color: #333333;
  }
  .submitButton {
    border: none;
    background: #f42551;
    color: #ffffff;
  }
}
</style>